export default "__VITE_ASSET__d2e61fd9__"